import { Globals } from '@bwoty-web/ui-kit';
import { hydrateRoot } from 'react-dom/client';
import CruiseShippingCompanyFaqView from '../shared/views/cruiseShippingCompanyFaq/CruiseShippingCompanyFaqView';

const initialStateCruiseShippingCompanyFaq =
  window.__INITIAL_STATE_CRUISE_SHIPPING_COMPANY_FAQ__;
delete window.__INITIAL_STATE_CRUISE_SHIPPING_COMPANY_FAQ__;
const cruiseShippingCompanyFaqRoot = document.getElementById(
  'cruise-shipping-company-faq-view',
);

if (cruiseShippingCompanyFaqRoot) {
  const { content, labels, siteSettings } =
    initialStateCruiseShippingCompanyFaq;
  hydrateRoot(
    cruiseShippingCompanyFaqRoot,
    <Globals siteId={siteSettings?.siteId}>
      <CruiseShippingCompanyFaqView content={content} labels={labels} />
    </Globals>,
  );
}
